<mat-form-field appearance="fill" style="width:100%;">
    <mat-label>Customer</mat-label>
    <input matInput [(ngModel)]="customerID" placeholder="Customer ID" (focus)="onFocus($event)" (blur)="onBlur()"
        (keyup.enter)="doBlur($event)" #customerIDInput>

    <mat-icon *ngIf="!isSearching" matSuffix>search</mat-icon>
    <mat-spinner *ngIf="isSearching" matSuffix diameter="24"></mat-spinner>
</mat-form-field>

<ng-template #customerSearchList>
    <h2 matDialogTitle>Customer Search</h2>
    <mat-dialog-content>
        <div *ngFor="let cust of customerSearchResults"><button mat-raised-button [matDialogClose]="cust" color="accent"
                class="customer-search-result">
                {{cust.AccountName}} ({{cust.CustomerID}})<br />
                <span *ngIf="cust.AddressLine1">{{cust.AddressLine1}}<br /></span>
                <span *ngIf="cust.AddressLine2">{{cust.AddressLine2}}<br /></span>
                {{cust.City}} {{cust.State}} {{cust.PostalCode}}<br />
                {{cust.Phone1}}
            </button></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button matDialogClose color="accent">Cancel</button>
    </mat-dialog-actions>
</ng-template>